import { useEffect } from "react";
import { Link } from "react-router-dom";
import { SERVICES } from "@/data/services";
import { CtaButtons } from "@/components/site/Seo";

export default function NotFound() {
  useEffect(() => {
    document.title = "Page introuvable | Conciergerie Familly 29";
    const m = document.querySelector('meta[name="robots"]');
    m?.setAttribute("content", "noindex, follow");
    const og = document.querySelector('meta[property="og:url"]');
    const previousOg = og?.getAttribute("content");
    og?.removeAttribute("content");
    const canonical = document.querySelector('link[rel="canonical"]');
    const previous = canonical?.getAttribute("href");
    canonical?.removeAttribute("href");
    return () => {
      m?.setAttribute("content", "index, follow");
      if (previousOg) og?.setAttribute("content", previousOg);
      if (previous) canonical?.setAttribute("href", previous);
    };
  }, []);
  return (
    <div className="mx-auto max-w-3xl px-5 py-24 text-center" data-testid="not-found">
      <h1 className="font-display text-5xl">Page introuvable</h1>
      <p className="mt-4 text-slate-600">Cette page n'existe pas ou a été déplacée. Voici nos principales pages :</p>
      <ul className="mt-8 flex flex-wrap justify-center gap-3">
        <li><Link to="/" className="rounded-full border px-4 py-2 text-sm font-semibold hover:border-[#D82C2C]">Accueil</Link></li>
        {SERVICES.map((s) => <li key={s.slug}><Link to={s.path} className="rounded-full border px-4 py-2 text-sm font-semibold hover:border-[#D82C2C]">{s.nom}</Link></li>)}
        <li><Link to="/tarifs-conciergerie-brest/" className="rounded-full border px-4 py-2 text-sm font-semibold hover:border-[#D82C2C]">Tarifs</Link></li>
      </ul>
      <div className="mt-10 flex justify-center"><CtaButtons id="notfound" /></div>
    </div>
  );
}
